var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBxRightArrowCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 1.993C6.48502 1.994 1.99902 6.48 1.99902 11.994C1.99902 17.508 6.48502 21.994 12 21.994C17.513 21.994 21.999 17.508 22 11.994C22 6.48 17.514 1.994 11.999 1.993ZM12 19.994C7.58802 19.994 3.99902 16.405 3.99902 11.994C3.99902 7.583 7.58802 3.994 11.999 3.993C16.411 3.994 20 7.583 20 11.994C19.999 16.405 16.41 19.994 12 19.994Z",
    fill: "#6B6B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.994H8V12.994H12V16L16.005 11.995L12 7.991V10.994Z",
    fill: "#6B6B6B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxRightArrowCircle);
export default __webpack_public_path__ + "static/media/bx-right-arrow-circle.22e91735c4688425b62f84d51b821600.svg";
export { ForwardRef as ReactComponent };